import styled from 'styled-components';

const StuksIndicatieWrap = styled.span`
    margin-left: .5rem;
    border-radius: 10px;
    padding: .25rem;
    background: #f2f2f2;
    display: flex;
    align-items: center;
    align-self: center;
    span {
        font-weight: bold;
    }
`;

interface Props {
    afgerond: number
    totaal: number
};

const StuksIndicatie = ({afgerond, totaal}: Props) => (
    <StuksIndicatieWrap><span>{afgerond}</span>/{totaal}</StuksIndicatieWrap>
);

export default StuksIndicatie;